import { jsonObject, jsonMember, jsonArrayMember } from 'typedjson';
import { assetsPlaceholder } from '../../constants/assetsPlaceholder';

@jsonObject
class BookmakerAssets {
	@jsonMember(String)
	public logo: string = assetsPlaceholder.bookmaker;
}

@jsonObject
export default class BookmakerModel {
	@jsonMember(String)
	public id: string = '';

	@jsonMember(String)
	public name: string = '';

	@jsonMember(String)
	public url: string = '';

	@jsonArrayMember(BookmakerAssets)
	public assets: BookmakerAssets[] = [];
}
